<template>
  <Modal
    :closeable="false"
    :showModal="showModal"
  >
    <template #header>
      <div class="d-flex justify-start">
        <h4 class="text-xl">ERC Update</h4>
      </div>
    </template>
    <template #body>
      <div>
        As of Thursday, September 14, 2023, <a
          target="_blank"
          href="https://www.irs.gov/newsroom/to-protect-taxpayers-from-scams-irs-orders-immediate-stop-to-new-employee-retention-credit-processing-amid-surge-of-questionable-claims-concerns-from-tax-pros"
        >the IRS has paused acceptance of all new ERC claims</a>.
        <br/>
        Explore other ways Lendio can help you with business financing.
      </div>
    </template>
    <template #footer>
      <div class="modal-footer">
        <NuxtLink type="button"
          :to="'/basic-info'"
          class="btn btn-primary"
          data-cy="goHome"
        ><span>Explore Financing</span></NuxtLink>
      </div>
    </template>
  </Modal>
</template>

<script>
import { mapState } from 'pinia'
import Modal from '~/components/modal.vue'
import { useTenantStore } from '~/store/tenant'

export default {
  components: {
    Modal
  },
  computed: {
    ...mapState(useTenantStore, ['isTenant']),
    showModal() {
      return false
      // return !this.isTenant
    }
  },
  data () {
    return {}
  },
}
</script>

<style lang="scss" scoped>
  .sign-modal {
    font-size: 12px;
  }
</style>
